import React, { useState, useEffect } from 'react';
import SwipeEvent from '../swipe-event';
import { Modal } from 'antd-mobile';
import './index.less';

type SwiperDialogProps = {
    showClose?: '' | 'left' | 'right' | 'center';
    maskClose?: boolean;
    showSure?: boolean;
    visible: boolean;
    title?: any;
    circle?: boolean;
    heightAuto?: boolean;
    onClose?: () => void;
    onSure?: () => void;
} & Props;

class SwiperDialog extends React.Component<SwiperDialogProps, State> {
    static defaultProps = {
        showClose: 'right',
        title: '',
        maskClose: true,
    };
    // 下滑事件
    onSwipeDown = () => {
        this.props.onClose && this.props.onClose();
    };

    render() {
        const { visible, showClose, showSure, title, heightAuto, circle, maskClose, className } = this.props;

        return (
            <Modal
                popup
                maskClosable={maskClose}
                className={`swiper-dialog ${heightAuto ? 'height_auto' : ''} ${circle ? 'circle' : ''} ${className}`}
                visible={visible}
                onClose={this.props.onClose}
                animationType="slide-up"
            >
                <div className="swiper-dialog-box">
                    <div className="swiper-dialog-hd">
                        {['left', 'right'].includes(showClose || '') && (
                            <div className={`swiper-close-btn ${showClose}`} onClick={this.onSwipeDown}>
                                <span className="at-icon iconfont at-icon-close"></span>
                            </div>
                        )}
                        {showClose === 'center' && <SwipeEvent className="swiper-close-bar" onSwipeDown={this.onSwipeDown} />}
                        {showSure ? (
                            <div className="swiper-dialog-tt">
                                <span className="title">{title}</span>
                                <span className="right" onClick={this.props.onSure}>
                                    确定
                                </span>
                            </div>
                        ) : (
                            !!title && (
                                <div className="swiper-dialog-tt">
                                    <span className="title">{title}</span>
                                </div>
                            )
                        )}
                    </div>
                    <div className="swiper-dialog-bd">{this.props.children}</div>
                </div>
            </Modal>
        );
    }
}

export default SwiperDialog;
